// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"e3e5bce5","498":"552e3e1b","513":"49309a47"}[chunkId] + ".chunk.js";
};